import { IonContent, IonModal } from "@ionic/react";
import React from "react";

type Props = {
  visible: boolean;
  reusePressed: () => void;
  cancelPressed: () => void;
};

const ReuseIncidentModal: React.FC<Props> = (props) => {
  return (
    <IonModal
      id="reuse-incident-modal"
      isOpen={props.visible}
      backdropDismiss={true}
      canDismiss={true}
      onDidDismiss={props.cancelPressed}
      className="fullscreen"
    >
      <IonContent>
        <div className="flex flex-col justify-between h-full">
          <div className="mt-4 px-4">
            <div className="text-20px font-bold leading-default tracking-[-0.1px] text-center text-grey-90">
              {"Add incident details"}
            </div>
            <div className="text-15px leading-[1.33] tracking-[-0.3px] text-center text-grey-90 mt-1">
              {"Do you want to add incident details from your last recorded incident?"}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="border-t border-t-grey-30">
              <button
                className="h-12 w-full"
                onClick={props.reusePressed}
              >
                <div className="text-16px font-semibold leading-default tracking-default text-center text-cta-blue">
                  {"Add previous details"}
                </div>
              </button>
            </div>
            <div className="border-t border-t-grey-30">
              <button
                className="h-12 w-full"
                onClick={props.cancelPressed}
              >
                <div className="text-16px leading-default tracking-default text-center text-cta-blue">{"Cancel"}</div>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default ReuseIncidentModal;
